<template>
  <div>
    <portal to="entry_header">
      <h1 v-if="entry.isPaid()">
        Withdraw Entry {{ entry.data.SKU }}
      </h1>
      <h1 v-else-if="entry.isWithdrawn()">
        Entry {{ entry.data.SKU }} withdrawn
      </h1>
      <h1 v-else>
        Delete Entry {{ entry.data.SKU }}
      </h1>
    </portal>

    <div v-if="!entry.isWithdrawn()">
      <p v-if="entry.isPaid()">
        Your entry will be withdrawn. If this entry was paid for, you will be refunded the full amount automatically through PayPal.
      </p>
      <p v-else>
        Are you sure you would like to permanently delete this entry?
      </p>
    </div>
    <div
      v-else
      class="uk-alert"
    >
      Your entry has been withdrawn, if you paid for this entry a refund will be automatically processed by PayPal.
    </div>

    <div
      v-if="error"
      class="uk-alert uk-alert-danger"
    />

    <portal to="entry_footer">
      <div
        v-if="!entry.isWithdrawn()"
        class="uk-width-1-1"
      >
        <div class="efFooter">
          <div class="efFooter__row">
            <button
              class="uk-button-primary uk-button-outline uk-button"
              @click="$emit('revert-step', true)"
            >
              <span class="uk-icon-chevron-left" /> Continue editing entry
            </button>
          </div>
          <div class="efFooter__row efNav">
            <button
              :disabled="processing"
              class="uk-button uk-button-danger"
              @click="processWithdraw"
            >
              {{ withdrawButtonText }}
            </button>
          </div>
        </div>
      </div>
      <div v-else />
    </portal>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import EventEntryModel from "../../models/EventEntryModel";

@Component
export default class Withdraw extends Vue {
  @Prop() entry!: EventEntryModel;

  processing = false;
  error = "";

  get withdrawButtonText(): string {
    if (this.processing) {
      return this.entry.isPaid() ? "Withdrawing entry..." : "Deleting entry...";
    }
    return this.entry.isPaid() ? "Yes, withdraw my entry" : "Delete entry";
  }

  processWithdraw(): void {
    this.processing = true;
    this.$store.dispatch("events/deleteEntry", this.entry).catch((errResp) => {
      this.error = errResp;
    }).finally(() => this.processing = false);
  }
}
</script>

<style scoped>

</style>
